<template>
    <el-popover
        placement="top-end"
        trigger="manual"
        :content="prompt"
        popper-class="error-popover"
        v-model="popoverShow">
        <el-input-number 
            v-if="inputType == 'input-number'"
            slot="reference"
            v-model="valueActive" 
            :size="size" 
            :step="1"
            :controls-position="controlsPosition"
            :controls="controls"
            :disabled="disabled"
            @change="handleChange"
            @focus="handleFocus"
        ></el-input-number>
        <el-input 
            v-else-if="inputType == 'input'"
            slot="reference"
            v-model="valueActive" 
            :size="size"
            oninput="value=value.replace(/[^\d]/g,'')"
            :disabled="disabled"
            @change="handleChange"
            @focus="handleFocus"
        ></el-input>
    </el-popover>
</template>
<script>
// 数值错误提示
export default {
    name: 'PopoverNum',
    props: {
        content: { type: String, default: '' },
        value: { type: Number, default: 0 },
        size: { type: String, default: '-' },
        controlsPosition: { type: String, default: '-' },
        controls: { type: Boolean, default: true },
        min: { type: Number, default: 1 },
        max: { type: Number, default: 1000 },
        type: { type: String, default: '' },
        maxlength: { type: Number, default: 9999 },
        inputType: { type: String, default: 'input-number' },
        disabled: { type: Boolean, default: false },
        valueType: { type: String, required: false, default: 'lengthValue' } // value类型，numValue数值大小 lengthValue长度大小
    },
    data() {
        return {
            popoverShow: false,
            valueActive: 0,
            prompt: '',
            getType: ''
        }
    },
    watch: {
        'value': {
            handler(newV) {
                this.valueActive = newV
            },
            immediate: true,
        },
        'type': {
            handler(newV) {
                this.getType = this.type == '' ? this.$t('main.Range') : this.type
            },
            immediate: true,
        },
    },
    created(){
    },
    methods:{
        getlength(number) {
            return number.toString().length
        },
        handleChange(e) {
            if (this.valueType == 'lengthValue' && e < 0)  {
                // 长度不允许小于0，但是数值可以小于0
                this.prompt = '输入值不能小于0'
                this.popoverShow = true
                setTimeout(() => {
                    this.valueActive = this.value
                })
                setTimeout(() => {
                    this.popoverShow = false
                }, 2000)
            } else if (this.getlength(e) <= this.maxlength) {
                this.prompt = this.content
                if (this.getType == this.$t('main.Range') && 
                    e > this.min - 1 && 
                    e < this.max + 1){
                    this.$emit('valueChange', e)
                    this.popoverShow = false
                } else if(this.getType == 'min<max' && e < this.max) {
                    this.$emit('valueChange', this.valueActive)
                    this.popoverShow = false
                } else if(this.getType == 'min>max' && e > this.min) {
                    this.$emit('valueChange', this.valueActive)
                    this.popoverShow = false
                }else {
                    this.popoverShow = true
                    setTimeout(() => {
                        this.valueActive = this.value
                    })
                    setTimeout(() => {
                        this.popoverShow = false
                    }, 2000)
                }
            } else {
                this.prompt = this.content
                this.popoverShow = true
                setTimeout(() => {
                    this.valueActive = this.value
                })
                setTimeout(() => {
                    this.popoverShow = false
                }, 2000)
            }
        },
        handleFocus() {
            this.valueActive = this.value
        }
    }
}
</script>
